import { render } from "./UserLoginTab.vue?vue&type=template&id=2624c6b7"
import script from "./UserLoginTab.vue?vue&type=script&lang=js"
export * from "./UserLoginTab.vue?vue&type=script&lang=js"
script.render = render

export default script